import { scoreColor } from "@/lib/status";

export default function ScoreGauge({ score = 0, size = 200 }) {
  const radius = (size - 24) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const offset = circ * (1 - pct);
  const color = scoreColor(score);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E2E8F0" strokeWidth="12" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="12"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s ease-out" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display font-black tracking-tighter leading-none" style={{ fontSize: size * 0.32, color }}>
          {score}
        </span>
        <span className="font-mono-plex text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-1">/ 100</span>
      </div>
    </div>
  );
}
